export function openCustomerService() {
  // 国外客服
  if (window.$_Tawk) {
    window.$_Tawk.toggle()
  }
  // 国内客服
  if (window.qimoChatClick) {
    window.qimoChatClick()
  }
}
